import Page from "~/pages/Page";
import { getApi, handleError, logout } from "~/auth";
import * as validation from "~/utils/validation";
import UI from "~/ui";
import { format, parse } from "date-fns";
import $ from "jquery";
import { gotoLogin } from "~/utils";
import { DatiAnagrafici } from "~/components/DatiAnagrafici";
import DocumentoModal from "~/components/modals/DocumentoModal";
import { SoggettoVenditaAcquistoModal } from "~/components/modals/SoggettoVenditaAcquistoModal";
import { initializeInputMasks } from "~/input-mask";
import { t } from "~/hooks/useI18n";
import { finishAuctionInfoLoading } from "~/pages/areariservata/AuctionInfoLoading";

import {
    DeleteDocumentoGara,
    DeleteDocumentoGaraByIdATByUserIdAndTipo,
    uploadDocumentoGara
} from "~/services/documentService";

// ✅ Importa utility validazione file
import {
    ALLOWED_FILE_EXTENSIONS,
    validateAndShowFileError,
    formatFileSize,
    showFileError,
    clearFileError,
    showCustomFileError,
    clearCustomFileError,
    validateMaskedFileInputWithBorder
} from "~/utils/fileValidation";

class AdPropostaAcquisto extends Page {
    private _btnSalvaProfilo: HTMLFormElement = document.getElementById("btnSalvaProfilo") as HTMLFormElement;
    private theFormStep3: HTMLFormElement = document.getElementById("formStep3") as HTMLFormElement;
    private theFormStep4: HTMLFormElement = document.getElementById("formStep4") as HTMLFormElement;
    private theFormStep5: HTMLFormElement = document.getElementById("formStep5") as HTMLFormElement;
    private formDataStep3: Record<string, string> = {};
    private formDataStep4: Record<string, string> = {};
    private formDataStep5: Record<string, string> = {};
    private _tabProfilo: DatiAnagrafici = new DatiAnagrafici();
    private _documentoModal: DocumentoModal = new DocumentoModal("#modalCaricaDocumentoUtente", "frmDocumentoUtente");
    private _SoggettoVenditaAcquistoModal: SoggettoVenditaAcquistoModal = new SoggettoVenditaAcquistoModal("#modalSoggettoVenditaAcquisto", "frmSoggettoVenditaAcquisto");
    private _bustaId: number = 0; // Aggiungi l'ID dell'offerta
    private _venditaId: number = 0; // Aggiungi l'ID della vendita
    private _lottoId: number = 0; //Aggiungi l?ID del lotto
    private _idAstaTelematica: number = 0; // Aggiungi l'ID dell'offerta
    private _modalitaAcquistoId: number = 0; // Aggiungi la modalità di acquisto
    private _tipoCauzione: number = 0; // Aggiungi il tipo cauzione
    private _cauzione: number | null = null; // Aggiungi la cauzione
    private _offertaMinima: number | null = null; // Aggiungi l'offerta minima'
    private _prezzoBase: number = 0; // Aggiungi l'offerta minima'
    private _dataFinePresentazione: string | null = null;
    private _dataFineGara: string | null = null;

    private UserId: number = 0; // Aggiungi l'ID dell'utente
    private userInfo: any = null; // Variabile globale per memorizzare le informazioni dell'utente
    private auth: any = null;

    // ✅ Snapshot dei dati per rilevare modifiche
    private _snapshotDatiProposta: string | null = null;
    private _existeDOP: boolean = false;

    constructor() {
        super("atdomandapartecipazione", "AT Domanda di partecipazione");
    }

    async pageStart(): Promise<void> {
        const that = this;
        initializeInputMasks();
        this.initDatetimeLocalYearGuard();

        // Inizializza la validazione dei campi
        this._lottoId = parseInt($("#hdLottoId").val() as string, 10);
        this._bustaId = parseInt($("#hdBustaId").val() as string, 10);
        this._venditaId = parseInt($("#hdVenditaId").val() as string, 10);
        this._idAstaTelematica = parseInt($("#hdIdAstaTelematica").val() as string, 10);
        this._modalitaAcquistoId = parseInt($("#modalitaAcquisto").val() as string, 10);
        this._tipoCauzione = parseInt($("#hdTipoCauzione").val() as string, 10);
        this._cauzione = parseInt($("#hdCauzione").val() as string, 10);
        this._offertaMinima = parseInt($("#hdOffertaMinima").val() as string, 10);
        this._prezzoBase = parseInt($("#hdPrezzoBase").val() as string, 10);

        this.auth = getApi();
        this.userInfo = this.auth.getCached("userInfo"); // Inizializza la variabile globale
        if (!this.userInfo) {
            gotoLogin();
            return Promise.reject("User not authenticated");
        }

        this.UserId = this.userInfo.anagraficaId; // Inizializza l'ID dell'utente

        let _ = this.spinner.spin();
        try {
            // ✅ 1. Prima chiamata iniziale (tutte e 4 le API)
            await this.InitialLoad();
        } catch (error) {
            console.error("Errore durante il caricamento iniziale:", error);
        } finally {
            this.spinner.stop();
        }

        const savedStep = sessionStorage.getItem("currentStep");
        if (savedStep) {
            // ✅ Attiva SEMPRE il tab profilo per caricare i dati
            let tab = this._tabProfilo;
            await tab.activate();
            await this._documentoModal.activate();

            await goToStep(Number(savedStep));
            sessionStorage.removeItem("currentStep");
        } else {
            // Attiva il tab Dati Personali
            let tab = this._tabProfilo;
            await tab.activate();
            console.log("Tab Dati Personali attivato");
            // Attivo il modal per il caricamento del documento utente
            await this._documentoModal.activate();

            // Nascondo il pulsante "Salva Profilo" nella pagina AtDomandaPartecipazione
            const context = $("[data-context='AtDomandaPartecipazione']");
            if (context.length > 0) {
                const btnSalvaProfilo = $("#btnSalvaProfilo");
                if (btnSalvaProfilo.length > 0) {
                    btnSalvaProfilo.addClass("d-none");
                }
            }
        }

        // Seleziona tutti i tab
        document.querySelectorAll('[data-bs-toggle="tab"]').forEach(function (tab) {
            tab.addEventListener('show.bs.tab', async function (event) {
                event.preventDefault();
                const currentTab = (event as any).relatedTarget as HTMLElement;
                const selectedTab = event.target as HTMLElement; // Tab che sta per essere selezionato

                if (!currentTab || !selectedTab) return;

                // Step del tab attualmente selezionato
                const selectedMatch = selectedTab.id.match(/step(\d+)-tab/);
                const selectedStepNumber = selectedMatch ? parseInt(selectedMatch[1], 10) : 0;

                // Step del tab precedente (già presente)
                const match = currentTab.id.match(/step(\d+)-tab/);
                const stepNumber = match ? parseInt(match[1], 10) : 0;

                const result = await isStepValid(selectedTab);
                if (result.isValid) {
                    await goToStep(selectedStepNumber);
                    // Ora puoi usare selectedStepNumber per sapere quale step è stato selezionato
                    console.log("Step selezionato:", selectedStepNumber);
                } else {

                    await goToStep(result.invalidStep ?? 1);
                    console.log("Step non valido:", result.invalidStep);
                }
            });
        });

        //controlla se sono presenti soggetti e visualizza o nasconde il pulsante aggiungi
        await this.loadStep2();

        // ✅ Inizializza lo snapshot se esiste già una DOP (Domanda di Partecipazione) caricata (caso rientro nel wizard)
        await this.inizializzaSnapshotSeEsisteDOP();
        //await this.controllaModifichePerStep5();

        async function isStepValid(tabElement: HTMLElement): Promise<{ isValid: boolean, invalidStep: number | null }> {
            console.log("Validazione step:", tabElement.id);
            switch (tabElement.id) {
                case "step01-tab":
                    if (!await that.ValidaStep01()) return { isValid: false, invalidStep: 1 };
                    break;
                case "step02-tab":
                    if (!await that.ValidaStep01()) return { isValid: false, invalidStep: 1 };
                    break;
                case "step03-tab":
                    if (!await that.ValidaStep01()) return { isValid: false, invalidStep: 1 };
                    if (!await that.ValidaStep02()) return { isValid: false, invalidStep: 2 };
                    break;
                case "step04-tab":
                    if (!await that.ValidaStep01()) return { isValid: false, invalidStep: 1 };
                    if (!await that.ValidaStep02()) return { isValid: false, invalidStep: 2 };
                    if (!await that.ValidaStep03()) return { isValid: false, invalidStep: 3 };
                    // ✅ Controlla se ci sono state modifiche quando si passa allo step 5
                    await that.controllaModifichePerStep5();
                    break;
                case "step05-tab":
                    if (!await that.ValidaStep01()) return { isValid: false, invalidStep: 1 };
                    if (!await that.ValidaStep02()) return { isValid: false, invalidStep: 2 };
                    if (!await that.ValidaStep03()) return { isValid: false, invalidStep: 3 };
                    if (!await that.ValidaStep04()) return { isValid: false, invalidStep: 4 };
                    break;
                case "step06-tab":
                    if (!await that.ValidaStep01()) return { isValid: false, invalidStep: 1 };
                    if (!await that.ValidaStep02()) return { isValid: false, invalidStep: 2 };
                    if (!await that.ValidaStep03()) return { isValid: false, invalidStep: 3 };
                    if (!await that.ValidaStep04()) return { isValid: false, invalidStep: 4 };
                    if (!await that.ValidaStep05()) return { isValid: false, invalidStep: 5 };
                    break;
            }
            return { isValid: true, invalidStep: null };
        }

        $("#btnAvantiStep2").on("click", async (e) => {
            e.preventDefault(); // Previene il comportamento predefinito del pulsante
            try {
                const isUpdated = await this.ValidaStep01();
                if (isUpdated) {
                    console.log("Profilo aggiornato correttamente");
                    // Passa allo step successivo
                    goToNextStep(1);
                } else {
                    console.log("Errore durante l'aggiornamento del profilo");
                }
            } catch (error) {
                console.error("Errore durante l'aggiornamento del profilo:", error);
            }
        });

        $("#btnAvantiStep3").on("click", async (e) => {
            e.preventDefault(); // Previene il comportamento predefinito del pulsante
            try {
                const isUpdated = await this.ValidaStep02();
                if (isUpdated) {
                    console.log("Step 'Modalità di acquisto' salvato con successo");
                    // Passa allo step successivo
                    goToNextStep(2);
                }
            } catch (error) {
                console.error("Errore durante il salvataggio Step 'Modalità di acquisto':", error);
            }
        });

        $("#btnAvantiStep4").on("click", async (e) => {
            e.preventDefault(); // Previene il comportamento predefinito del pulsante
            try {
                const result = await that.ValidaStep03();
                if (!result) return;
                await that.controllaModifichePerStep5();
                goToNextStep(3);

            } catch (error) {
                console.error("Errore durante il salvataggio Step 3:", error);
            }

        });

        $("#btnAvantiStep5").on("click", async (e) => {
            e.preventDefault(); // Previene il comportamento predefinito del pulsante
            try {
                if (this._tipoCauzione == 4) {
                    /* Nessuna cauzione richiesta */
                    goToNextStep(4);
                } else {

                    const result = await that.ValidaStep04();

                    if (!result) return;
                    await that.controllaModifichePerStep5();
                    goToNextStep(4);
                }

            } catch (error) {
                console.error("Errore durante il salvataggio Step 4:", error);
            }

        })

        $("#btnAvantiStep6").on("click", async (e) => {
            e.preventDefault(); // Previene il comportamento predefinito del pulsante
            try {
                const result = await that.ValidaStep05();
                if (!result) return;

                // ✅ Non fare reload, passa direttamente allo step 6
                //goToNextStep(5);

                sessionStorage.setItem("currentStep", "6");
                window.location.reload();

            } catch (error) {
                console.error("Errore durante il salvataggio Step 4:", error);
            }

        })

        $("#btnIndietroStep1").on("click", async (e) => {
            e.preventDefault(); // Previene il comportamento predefinito del pulsante
            goToPrevStep(2);
        })

        $("#btnIndietroStep2").on("click", async (e) => {
            e.preventDefault(); // Previene il comportamento predefinito del pulsante
            goToPrevStep(3);
        })

        $("#btnIndietroStep3").on("click", async (e) => {
            e.preventDefault(); // Previene il comportamento predefinito del pulsante
            goToPrevStep(4);
        })

        $("#btnIndietroStep4").on("click", async (e) => {
            e.preventDefault(); // Previene il comportamento predefinito del pulsante
            goToPrevStep(5);
        })

        $("#btnIndietroStep5").on("click", async (e) => {
            e.preventDefault(); // Previene il comportamento predefinito del pulsante
            goToPrevStep(6);
        })


        async function goToStep(stepNumber: number) {
            // Rimuove 'active' da tutti i tab
            $("[id^='step'][id$='-tab']").removeClass("active");
            // Rimuove 'show active' da tutti i tab-pane
            $("[id^='step'][id$='-tab-pane']").removeClass("show active");

            // Aggiunge 'active' al tab selezionato
            $(`#step${stepNumber.toString().padStart(2, '0')}-tab`).addClass("active");
            // Aggiunge 'show active' al tab-pane selezionato
            $(`#step${stepNumber.toString().padStart(2, '0')}-tab-pane`).addClass("show active");
            window.scrollTo({ top: 0, behavior: "smooth" });

            if (stepNumber === 6) {
               await that.refreshStep6();
            }
        }

        function goToNextStep(currentStepNumber: number) {
            const currentStepTab = $(`#step${currentStepNumber.toString().padStart(2, '0')}-tab`);
            const currentStepTabPane = $(`#step${currentStepNumber.toString().padStart(2, '0')}-tab-pane`);
            const nextStepNumber = currentStepNumber + 1;
            const nextStepTab = $(`#step${nextStepNumber.toString().padStart(2, '0')}-tab`);
            const nextStepTabPane = $(`#step${nextStepNumber.toString().padStart(2, '0')}-tab-pane`);

            if (currentStepTab.length > 0 && nextStepTab.length > 0) {
                currentStepTab.removeClass("active");
                currentStepTabPane.removeClass("show active");
                nextStepTab.addClass("active");
                nextStepTabPane.addClass("show active");
            }
            window.scrollTo({ top: 0, behavior: "smooth" });
            if (nextStepNumber === 6) {
                that.refreshStep6();
            }
        }

        function goToPrevStep(currentStepNumber: number) {
            const currentStepTab = $(`#step${currentStepNumber.toString().padStart(2, '0')}-tab`);
            const currentStepTabPane = $(`#step${currentStepNumber.toString().padStart(2, '0')}-tab-pane`);
            const prevStepNumber = currentStepNumber - 1;
            const prevStepTab = $(`#step${prevStepNumber.toString().padStart(2, '0')}-tab`);
            const prevStepTabPane = $(`#step${prevStepNumber.toString().padStart(2, '0')}-tab-pane`);

            if (currentStepTab.length > 0 && prevStepTab.length > 0) {
                currentStepTab.removeClass("active");
                currentStepTabPane.removeClass("show active");
                prevStepTab.addClass("active");
                prevStepTabPane.addClass("show active");
            }
            window.scrollTo({ top: 0, behavior: "smooth" });
        }

        const titoliModalita: Record<string, string> = {
            "2": t("common.DatiSocietaEnte"),
            "3": t("common.DatiPersonaFisicaGiuridica"),
            "4": t("common.DatiContitolare"),
            "6": t("common.DatiSoggettoAmministrato"),
        };

        $("#modalitaAcquisto").on("change", async (e) => {

            const selectValue = $("#modalitaAcquisto").val() as string;
            const idModalitaAcquisto = Number(selectValue);

            // Validazione valore selezionato
            if (isNaN(idModalitaAcquisto) || !selectValue) {
                UI.confirmOneButton("", t("messages.selezionareModalitaAcquistoValida"));
                return;
            }


            // Conferma se ci sono soggetti già inseriti
            const soggettiPresenti = $("#divElencoSoggettiVenditaAcquisto .soggetto-item").length > 0;
            if (soggettiPresenti) {
                const conferma = await new Promise<boolean>(resolve => {
                    UI.confirm("", t("messages.confirmChangePurchaseMode"), "", resolve);
                });
                if (!conferma) {
                    // ✅ Ripristina il valore precedente e trigghera l'evento change
                    $("#modalitaAcquisto").val(this._modalitaAcquistoId.toString());
                    return;
                }
            }

            try {
                // Salva il valore tramite una chiamata API
                const response = await this.SalvaModalitaAcquisto(idModalitaAcquisto);

                if (!response) {
                    console.info("Errore durante il salvataggio della modalità di acquisto.");
                    UI.confirmOneButton("", t("messages.errorSavingPurchaseMode")); // Feedback all'utente
                    return;
                }

                // Rimuovi soggetti precedenti
                $("#divElencoSoggettiVenditaAcquisto .soggetto-item").remove();

                this.controllaVisibilitaPulsanteAggiungiSoggetto();

                // Aggiorna attributi modale
                $("#modalSoggettoVenditaAcquisto")
                    .attr("data-modalita-acquisto", selectValue)
                    .attr("data-busta-id", this._bustaId)
                    .attr("data-vendita-id", this._venditaId)
                    .attr("data-astatelematica-id", this._idAstaTelematica);

                // Nascondi tutti i div
                [
                    "#divSoggettiVenditaAcquisto",
                    "#divPerSocieta",
                    "#divPerProcura",
                    "#divInComproprieta",
                    "#divDaTutore"
                ].forEach(sel => $(sel).addClass("d-none"));

                // Mappa delle classi da mostrare in base al valore di selectValue
                const visibilityMap: Record<string, string[]> = {
                    "2": ["#divSoggettiVenditaAcquisto", "#divPerSocieta"],
                    "3": ["#divSoggettiVenditaAcquisto", "#divPerProcura"],
                    "4": ["#divSoggettiVenditaAcquisto", "#divInComproprieta"],
                    "6": ["#divSoggettiVenditaAcquisto", "#divDaTutore"]
                };

                //Imposta il titolo della modale in base alla modalità di acquisto selezionata
                const titolo = titoliModalita[selectValue] || "Seleziona modalità di acquisto";
                $("#SoggettiVenditaAcquistoLabel").text(titolo);

                //Mostra i div corrispondenti al valore selezionato
                if (visibilityMap[selectValue]) {
                    visibilityMap[selectValue].forEach(selector => $(selector).removeClass("d-none"));
                }

                //controllo se è presente la DOP e nel caso la rimuovo perchè
                //con il cambio di modalità di acquisto la DOP deve essere nuovamente generata
                const dopCancellata: boolean = await DeleteDocumentoGaraByIdATByUserIdAndTipo(this._idAstaTelematica, this.UserId, "DOP");
                //const dopCancellata: boolean = false;

                if (dopCancellata) {
                    $("#div-upload-file-dop").removeClass("d-none");
                    $("#domanda-file-dop").val("").attr("required", "required");
                    $("#div-file-dop").addClass("d-none");
                    UI.confirmOneButton("", t("messages.dopDeletedChangeMode"));
                }
            } catch (error) {
                console.error("Errore:", error);
                UI.confirmOneButton("", t("messages.errorSaving")); // Feedback all'utente
            }
        });

        $("#modalSoggettoVenditaAcquisto")
            .attr("data-modalita-acquisto", this._modalitaAcquistoId)
            .attr("data-busta-id", that._bustaId)
            .attr("data-vendita-id", that._venditaId)
            .attr("data-astatelematica-id", this._idAstaTelematica);

        // Attivo il modal per la gestione dei comproprietari
        await this._SoggettoVenditaAcquistoModal.activate();




        /*********************************************************************************************************/
        /***************************************** STEP 3 ********************************************************/
        /*********************************************************************************************************/
        // $("#domanda-importo-offerto").on("blur", async (e) => {
        //     e.preventDefault();
        //     await this.validateImportoOfferto();
        // });

        // $("#domanda-importo-cauzione").on("blur", async (e) => {
        //     e.preventDefault();
        //     await this.validateImportoCauzione();
        // });

        /*********************************************************************************************************/
        /***************************************** STEP 4 ********************************************************/
        /*********************************************************************************************************/

        // ✅ Validazione file al momento della selezione
        $("#domanda-file-contabile").on("change", function () {
            const fileInput = this as HTMLInputElement;
            if (fileInput.files && fileInput.files.length > 0) {
                validateAndShowFileError(fileInput, fileInput.files[0]);
            }
        });

        $(".delete-contabile").on("click", async function (e) {

            console.info("Sono passata dalla delete-contabile click");

            e.preventDefault();
            const allegatoId = $(this).data("id");
            if (!allegatoId) return;

            UI.confirm(t("common.confirm"), t("messages.confirmDelete"), "", async (result) => {

                console.log("Conferma eliminazione allegato gara:", result);
                if (!result) {
                    return;
                }

                await DeleteDocumentoGara(allegatoId);

                $(this).closest(".allegato-cauzione-item").remove();

                // Controlla se ci sono altri allegati
                if ($(".allegato-cauzione-item").length === 0) {
                    $("#div-upload-file-contabile-domanda").removeClass("d-none");
                    $("#domanda-file-contabile").val("").attr("required", "required");
                    $("#domanda-file-contabile").removeAttr("disabled");
                }
                UI.confirmOneButton("", t("messages.attachmentDeletedSuccess"));

            });
        });

        /*********************************************************************************************************/
        /***************************************** STEP 5 ********************************************************/
        /*********************************************************************************************************/

        $(".btnDowloadDop").on("click", async function (e) {
            e.preventDefault();
            const bustaId = that._bustaId;
            if (!bustaId) return;
            await that.GeneraPdfDop(bustaId);
        })

        // ✅ Validazione file DOP mascherato con bordo rosso
        $("#domanda-file-dop").on("change", function () {
            const fileInput = this as HTMLInputElement;
            if (fileInput.files && fileInput.files.length > 0) {
                validateMaskedFileInputWithBorder(fileInput, fileInput.files[0], "fileDopName");
            }
        });

        // ✅ Validazione file AntiRiciclaggio mascherato con bordo rosso
        $("#domanda-file-antiriciclaggio").on("change", function () {
            const fileInput = this as HTMLInputElement;
            if (fileInput.files && fileInput.files.length > 0) {
                validateMaskedFileInputWithBorder(fileInput, fileInput.files[0], "fileAntiName");
            }
        });

        // ✅ Validazione file al momento della selezione
        $("#domanda-file-altro-documento").on("change", function () {
            const fileInput = this as HTMLInputElement;
            if (fileInput.files && fileInput.files.length > 0) {
                validateAndShowFileError(fileInput, fileInput.files[0]);
            }
        });

        $(".delete-dop").on("click", async function (e) {
            e.preventDefault();
            const allegatoId = $(this).data("id");
            if (!allegatoId) return;

            UI.confirm(t("common.confirm"), t("messages.confirmDelete"), "", async (result) => {

                console.log("Conferma eliminazione allegato gara:", result);
                if (!result) {
                    return;
                }

                await DeleteDocumentoGara(allegatoId);

                $(this).closest(".allegato-dop-item").remove();

                // Controlla se ci sono altri allegati
                if ($(".allegato-dop-item").length === 0) {
                    $("#div-upload-file-dop").removeClass("d-none");
                    $("#domanda-file-dop").val("").attr("required", "required");
                    $("#fileDopName").html("");

                    // ✅ Reset snapshot
                    that._snapshotDatiProposta = null;
                    that._existeDOP = false;

                }
                UI.confirmOneButton("", t("messages.attachmentDeletedSuccess"));
            });
        });

        $(".delete-antiriciclaggio").on("click", async function (e) {
            e.preventDefault();
            const allegatoId = $(this).data("id");
            if (!allegatoId) return;

            UI.confirm(t("common.confirm"), t("messages.confirmDelete"), "", async (result) => {

                console.log("Conferma eliminazione allegato gara:", result);
                if (!result) {
                    return;
                }

                await DeleteDocumentoGara(allegatoId);

                $(this).closest(".allegato-antiriciclaggio-item").remove();

                // Controlla se ci sono altri allegati
                if ($(".allegato-antiriciclaggio-item").length === 0) {
                    $("#div-upload-file-antiriciclaggio").removeClass("d-none");
                    $("#domanda-file-antiriciclaggio").val("").attr("required", "required");
                    $("#fileAntiName").html("");
                }
                UI.confirmOneButton("", t("messages.attachmentDeletedSuccess"));
            });
        });

        $(".delete-altrodocumento").on("click", async function (e) {
            e.preventDefault();
            const allegatoId = $(this).data("id");
            if (!allegatoId) return;

            UI.confirm(t("common.confirm"), t("messages.confirmDelete"), "", async (result) => {

                console.log("Conferma eliminazione allegato gara:", result);
                if (!result) {
                    return;
                }

                await DeleteDocumentoGara(allegatoId);

                $(this).closest(".allegato-altro-documento-item").remove();

                // Controlla se ci sono altri allegati
                if ($(".allegato-altro-documento-item").length === 0) {
                    $("#div-upload-file-altro-documento").removeClass("d-none");
                    $("#domanda-file-altro-documento").val("");
                }
                UI.confirmOneButton("", t("messages.attachmentDeletedSuccess"));
            });
        });

        /*********************************************************************************************************/
        /***************************************** STEP 6 ********************************************************/
        /*********************************************************************************************************/

        $("#btnInviaBusta").on("click", async function (e) {

            e.preventDefault();

            const $btn = $(this);

            // Evita invii multipli in caso di doppio click / click ripetuti
            if ($btn.prop("disabled") || $btn.data("isSubmitting")) {
                return;
            }

            const bustaId = that._bustaId;
            if (!bustaId) return;

            //Controllo se è sempre possibile inviare l'offerta
            if (that._dataFinePresentazione) {
                const deadline = new Date(that._dataFinePresentazione);
                const now = new Date();

                if (now > deadline) {
                    UI.confirmOneButton(t("messages.titleDeadlineExpired"), t("messages.submissionDeadlineExpired"), "", function (result) {
                        if (result) {
                            window.location.href = window.BaseUrlWeb + "monitoraggio-offerte-" + that._lottoId;
                        }
                    });
                    return;
                }
            }

            UI.confirm("", t("messages.confirmSendParticipationRequest"), "", async (result) => {
                if (!result) {
                    return;
                }

                // Disabilita il pulsante per impedire invii multipli finché non termina la richiesta
                $btn.data("isSubmitting", true).prop("disabled", true);

                try {
                    const busta: any = await that.InviaBusta();

                    if (busta) {

                        UI.confirmOneButtonCustom("Offerta registrata!", `Ricorda di monitorare la sezione 'Le tue offerte' nella tua area riservata per: 
                                                                            <ul>
                                                                            <li>Accertare l’ammissione della tua offerta</li>
                                                                            <li>Verificare la presenza di altri eventuali offerenti</li>
                                                                            <li>Seguire in tempo reale lo svolgimento della gara</li>
                                                                            <li>Partecipare all’asta e rilanciare!</li>
                                                                            </ul>`,
                            "Torna alla tua area riservata", "", function (result) {
                                if (result) {
                                    window.location.href = window.BaseUrlWeb + "stato-asta-telematica-" + that._idAstaTelematica;
                                }
                            });


                    } else {
                        UI.confirmOneButton("", t("messages.errorSendingOffer"));
                    }
                } finally {
                    // Riabilita il pulsante solo se l'invio non ha avuto successo
                    // (in caso di successo l'utente viene reindirizzato altrove)
                    $btn.data("isSubmitting", false).prop("disabled", false);
                }
            })

        });


        return Promise.resolve();
    }

    // ✅ Limita l'anno a max 4 cifre negli input datetime-local
    private initDatetimeLocalYearGuard(): void {
        $(document).on("input change", "input[type='datetime-local']", function () {
            const input = this as HTMLInputElement;
            const val = input.value;

            // ✅ Se il campo è vuoto, rimuovi eventuali errori precedenti e lascia
            // che la validazione required del form faccia il suo lavoro
            if (!val) {
                $(input).removeClass("is-invalid");
                $(input).siblings(".invalid-feedback.datetime-error").remove();
                return;
            }

            const date = new Date(val);
            const year = date.getFullYear();
            const isInvalidDate = isNaN(date.getTime());
            const isYearTooLong = year > 9999;

            if (isInvalidDate || isYearTooLong) {
                // Azzera il valore non valido
                input.value = "";

                // Aggiunge classe Bootstrap is-invalid
                $(input).addClass("is-invalid");

                // Cerca un .invalid-feedback già esistente specifico per questo controllo
                let $error = $(input).siblings(".invalid-feedback.datetime-error");
                const message = isYearTooLong
                    ? t("validation.yearTooLong")   // es. "L'anno non può avere più di 4 cifre"
                    : t("validation.invalidDate");  // es. "Data non valida"

                if ($error.length === 0) {
                    // Crea il div di errore se non esiste (stesso pattern di showFileError)
                    $(input).after(`<div class="invalid-feedback datetime-error d-block">${message}</div>`);
                } else {
                    $error.text(message).removeClass("d-none").addClass("d-block");
                }
            } else {
                // ✅ Data valida: rimuovi errori
                $(input).removeClass("is-invalid");
                $(input).siblings(".invalid-feedback.datetime-error").remove();
            }
        });
    }

    // ✅ Nuovo metodo per il caricamento iniziale
    private async InitialLoad(): Promise<void> {
        console.info("📥 Caricamento iniziale dati asta...");

        try {
            // 1. Prima chiama RefreshDatiAsta per popolare statoGaraCorrente
            await this.RefreshDatiAsta();

            console.info(`✅ Caricamento iniziale completato`);
        } catch (error) {
            console.error("❌ Errore nel caricamento iniziale:", error);
        } finally {
            finishAuctionInfoLoading();
        }
    }

    private async RefreshDatiAsta() {

        if (this._idAstaTelematica > 0) {
            const url = window.BaseUrlWebApi + "AsteTelematiche/StatoVendita?idAstaTelematica=" + this._idAstaTelematica;
            const statoAsta = await this.auth.fetchWithAuth("GET " + url, {
                cache: "no-cache",
                headers: { 'content-type': 'application/json' },
            });

            if (!statoAsta || statoAsta.length === 0) {
                return;
            }

            await this.PopolaInfoAsta(statoAsta);
        }
    }

    private async PopolaInfoAsta(obj: any) {
        const that = this;

        //se non è possibile più presentare domanda di partecipazione visualizzo messaggio
        //e rimando alla pagina di monitoraggio
        this._dataFinePresentazione = obj.DataFineCauzione;

        //Controllo se è sempre possibile inviare l'offerta
        if (this._dataFinePresentazione) {
            const deadline = new Date(this._dataFinePresentazione);
            const now = new Date();

            if (now > deadline) {
                UI.confirmOneButton(t("messages.titleDeadlineExpired"), t("messages.submissionDeadlineExpired"), "", function (result) {
                    if (result) {
                        window.location.href = window.BaseUrlWeb + "monitoraggio-offerte-" + that._lottoId;
                    }
                });
                return; // ✅ Interrompe l'esecuzione, evita di popolare i dati
            }
        }


        //Dati partial "/AstaTelematica/_InfoTipoAsta 1 o 2"
        $("#data-inizio-presentazione-offerte").html(UI.formatDateIsoToIt(obj.DataInizioCauzione));
        $("#ora-inizio-presentazione-offerte").html(UI.formatTimeIsoToHms(obj.DataInizioCauzione));

        $("#data-fine-presentazione-offerte").html(UI.formatDateIsoToIt(obj.DataFineCauzione));
        $("#ora-fine-presentazione-offerte").html(UI.formatTimeIsoToHms(obj.DataFineCauzione));

        $("#data-inizio-gara").html(UI.formatDateIsoToIt(obj.DataInizio));
        $("#ora-inizio-gara").html(UI.formatTimeIsoToHms(obj.DataInizio));

        this._dataFineGara = obj.DataFine;
        $("#data-fine-gara").html(UI.formatDateIsoToIt(obj.DataFine));
        $("#ora-fine-gara").html(UI.formatTimeIsoToHms(obj.DataFine));

        //DATI PARTIAL "/AstaTelematica/_InformazioniGara"
        $("#prezzo-base").html(UI.formatEuroCurrency(obj.PrezzoBase));

        if (obj.PrezzoRiserva > 0) {
            $("#prezzo-riserva").html(UI.formatEuroCurrency(obj.PrezzoRiserva));

        } else {
            $("#li-offerta-minima").addClass("d-none");
        }

        // ✅ Formatta cauzione
        const tipoCauzione = await this.getTipoCauzioneLabel(obj.TipoCauzione);
        $("#tipo-cauzione").html(tipoCauzione);

        if (obj.TipoCauzione == 1) {
            $("#cauzione").html(UI.formatEuroCurrency(obj.Cauzione));
        } else {
            $("#cauzione").html(obj.Cauzione + " " + tipoCauzione);
            if (obj.tipoCauzione == 4) {
                $("#divCauzione").addClass("d-none");
                $("domanda-importo-cauzione").removeAttr("required");
            }
        }

        if (obj.RialzoMinimo > 0) {
            $("#rialzo-minimo").html(UI.formatEuroCurrency(obj.RialzoMinimo));
            $(".rilancio").removeClass("d-none");
        } else {
            $(".rilancio").addClass("d-none");
        }
        //$("#numero-partecipanti").html(obj.NumeroPartecipanti);

        // ✅ Formatta anticipo
        const anticipoValore = obj.Anticipo ?? 0;
        const anticipo = await this.formatTempoAnticipo(anticipoValore);

        // ✅ Formatta prolungamento
        const prolungamentoValore = obj.Prolungamento ?? 0;
        const prolungamento = await this.formatTempoProlungamento(prolungamentoValore);

        // ✅ Estensioni
        const estensioniValore = obj.Estensioni ?? 0;

        // ✅ Controlla se tutti i valori sono 0 per nascondere i prolungamenti
        if (anticipoValore === 0 && prolungamentoValore === 0 && estensioniValore === 0) {
            $(".prolungamenti").addClass("d-none");
        } else {
            $(".prolungamenti").removeClass("d-none");
        }
        $(".prolungamenti-attivati").addClass("d-none");

        $("#anticipo").html(anticipo);
        $("#prolungamento").html(prolungamento);

        if (estensioniValore === 0) {
            $("#estensioni").html(t("common.illimitati"));
        } else {
            $("#estensioni").html(estensioniValore);
        }

        $("#numero-prolungamento").html(obj.NumeroProlungamento);


    }

    private async getTipoCauzioneLabel(tipoCauzioneId: number): Promise<string> {
        let label = "";

        switch (tipoCauzioneId) {
            case 1:
                label = "";
                break;
            case 2:
                label = t("common.percPrezzoOfferto");
                break;
            case 3:
                label = t("common.percPrezzoBase");
                break;
            case 4:
                label = t("common.nessunaCauzione");
                break;
            default:
                label = "-";
                break;
        }

        return label;
    }

    private async formatTempoAnticipo(anticipoMin: number): Promise<string> {
        if (anticipoMin <= 0) {
            return "-";
        }

        let value: number;
        let labelKey: string;

        if (anticipoMin >= 1440) {
            // Converti in giorni
            value = Math.floor(anticipoMin / 1440);
            labelKey = value === 1 ? t("common.giorno") : t("common.giorni");
        } else if (anticipoMin >= 60) {
            // Converti in ore
            value = Math.floor(anticipoMin / 60);
            labelKey = value === 1 ? t("common.ora") : t("common.ore");
        } else {
            // Mantieni in minuti
            value = anticipoMin;
            labelKey = value === 1 ? t("common.minuto") : t("common.minuti");
        }

        return `${value} ${labelKey}`;
    }

    private async formatTempoProlungamento(prolungamentoMin: number): Promise<string> {
        if (prolungamentoMin <= 0) {
            return "-";
        }

        let value: number;
        let labelKey: string;

        if (prolungamentoMin >= 1440) {
            value = Math.floor(prolungamentoMin / 1440);
            labelKey = value === 1 ? t("common.giorno") : t("common.giorni");
        } else if (prolungamentoMin >= 60) {
            value = Math.floor(prolungamentoMin / 60);
            labelKey = value === 1 ? t("common.ora") : t("common.ore");
        } else {
            value = prolungamentoMin;
            labelKey = value === 1 ? t("common.minuto") : t("common.minuti");
        }

        return `${value} ${labelKey}`;
    }


    private async InviaBusta(): Promise<void> {
        let _ = this.spinner.spin();
        const url = window.BaseUrlWebApi + "AsteTelematiche/InviaBusta?bustaId=" + this._bustaId;
        try {
            const busta = await this.auth.fetchWithAuth("GET " + url, {
                cache: "no-cache",
                headers: { 'content-type': 'application/json' },
            });
            console.log("salvataggio avvenuto con successo.");
            return busta;
        } catch (error) {
            console.info(error);
            UI.confirmOneButton("", t("messages.errorSendingEnvelope"));
        } finally {
            this.spinner.stop();
        }
    }

    /********************************************************************************************************/
    /*************************************** STEP 1 DATI OFFERENTE ******************************************/
    /********************************************************************************************************/

    private async ValidaStep01(): Promise<boolean> {
        //PRIMA CONTROLLO CHE IL PROFILO SIA COMPLETO
        const isUpdated = await this._tabProfilo.updateProfile(true); // Richiama il metodo updateProfile
        if (!isUpdated)
            return false;

        // Controlla se il documento utente è stato caricato
        const existDocUtente = await this._documentoModal.checkDocumentoUtente(this.UserId);
        if (!existDocUtente) {
            UI.confirmOneButton("", t("messages.needUploadUserDocument")); // TODO: i18n
            return false;
        }

        return true;
    }

    /********************************************************************************************************/
    /*************************************** STEP 2 MODALITA DI ACQUISTO ************************************/
    /********************************************************************************************************/
    private async ValidaStep02(): Promise<boolean> {
        // Controlla se il documento utente è stato caricato
        const selectValue = $("#modalitaAcquisto").val() as string;
        const idModalitaAcquisto = Number(selectValue);
        if (isNaN(idModalitaAcquisto) || selectValue == null || selectValue === "") {

            UI.confirmOneButton("", t("messages.selectValidPurchaseMode"));
            return false;
        } else {
            if (idModalitaAcquisto != 1) {
                //Controllo se è presente almeno un soggetto acquirente
                const esisteAlmenoUnSoggetto = $(".soggetto-item").length > 0;
                if (!esisteAlmenoUnSoggetto) {
                    UI.confirmOneButton("", t("messages.addSoggettoAcquisto"));
                    return false;
                }
            }
        }
        return true;
    }

    private async SalvaModalitaAcquisto(idModalitaAcquisto: number): Promise<boolean> {
        console.info(idModalitaAcquisto + " - " + this._bustaId);
        let url = window.BaseUrlWebApi + "AsteTelematiche/SalvaModalitaAcquisto?idModalitaAcquisto=" + idModalitaAcquisto + "&bustaId=" + this._bustaId;

        try {
            const response = await this.auth.fetchWithAuth("GET " + url, {
                cache: "no-cache",
                headers: { 'content-type': 'application/json' },
            });

            if (response.size > 0) {
                throw new Error(`Errore durante il salvataggio della modalità di acquisto`);
            }

            console.log("Modalità di acquisto salvata con successo.");
            return true;

        } catch (error) {
            console.info("Errore durante il salvataggio della modalità di acquisto", error);
            return false;
        }

    }

    private async loadStep2(): Promise<void> {

        // ✅ Controlla visibilità iniziale
        this.controllaVisibilitaPulsanteAggiungiSoggetto();

        // ✅ ASCOLTA gli eventi per aggiornare quando cambia qualcosa
        $(document).off("soggettoAggiunto soggettoEliminato"); // Rimuovi listener precedenti

        $(document).on("soggettoAggiunto soggettoEliminato", () => {
            console.info("Evento soggetto modificato, ricontrollo visibilità pulsante");
            this.controllaVisibilitaPulsanteAggiungiSoggetto();
        });
    }


    private controllaVisibilitaPulsanteAggiungiSoggetto(): void {
        // Controlla se ci sono soggetti già inseriti
        const numSoggetti = $("#divElencoSoggettiVenditaAcquisto .soggetto-item").length;

        // Recupera l'ID modalità acquisto
        const idModalitaAcquisto = parseInt($("#modalitaAcquisto").val() as string) || 0;

        // Se c'è almeno un soggetto E la modalità NON è "In Comproprietà" (4)
        // nascondi il pulsante "Aggiungi"
        if (idModalitaAcquisto == 1) {
            $(".btnAggiungiSoggetto").addClass("d-none");
        } else if (numSoggetti > 0 && idModalitaAcquisto !== 4) {
            $(".btnAggiungiSoggetto").addClass("d-none");
            console.info(`Pulsante "Aggiungi Soggetto" nascosto: ${numSoggetti} soggetti presenti, modalità ${idModalitaAcquisto}`);
        } else {
            $(".btnAggiungiSoggetto").removeClass("d-none");
        }
    }

    /********************************************************************************************************/
    /*************************************** STEP 3 OFFERTA E CAUZIONE **************************************/
    /********************************************************************************************************/

    private async ValidaStep03(): Promise<boolean> {
        this.addValidationFormStep3();
        this.theFormStep3.classList.remove("was-validated");
        try {
            // ✅ Esegue i validator su tutti i campi e imposta is-invalid + messaggio
            this.onSubmitValidator();

            // ✅ Controlla la validità del form (sia required HTML che setCustomValidity)
            if (!this.theFormStep3.checkValidity()) {
                this.theFormStep3.classList.add("was-validated");
                return false;
            }

            await this.submitStep3();
            return true;
        } catch (error) {
            console.error("Errore nel submitStep3:", error);
            return false;
        }
    }

    private addValidationFormStep3(): void {
        const that = this;
        const form = this.theFormStep3;
        // Rimuove la classe di validazione quando l'utente modifica i campi
        form.addEventListener("input", () => {
            form.classList.remove("was-validated");
        });

        const inputValidator = (inputElement: HTMLInputElement): validation.ValidationResult => {
            if (!$(inputElement).is(":visible")) {
                return { ok: true, error: "" };
            }
            const inputValue = $(inputElement).val() as string;
            const isValid = inputValue.length > 0;

            return {
                ok: isValid,
                error: isValid ? "" : t("validation.required")
            };
        }

        // ── Validator: importo offerto (required + offerta minima + prezzo base) ──
        const importoOffertoValidator = (inputElement: HTMLInputElement): validation.ValidationResult => {
            if (!$(inputElement).is(":visible")) return { ok: true, error: "" };

            const valore = ($(inputElement).val() as string) ?? "";
            const numero = parseFloat(valore.replace(/\./g, ""));

            if (isNaN(numero) || valore === "") {
                return { ok: false, error: t("messages.enterOfferAmount") };
            }
            if (this._offertaMinima !== null && this._offertaMinima > 0) {
                if (numero < this._offertaMinima) {
                    const amount = this._offertaMinima.toLocaleString("it-IT", {
                        style: "currency", currency: "EUR",
                        minimumFractionDigits: 0, maximumFractionDigits: 0
                    });
                    return { ok: false, error: t("messages.amountLowerThanMinimumOffer", { amount }) };
                }
            } else if (this._prezzoBase != null && this._prezzoBase > 0) {
                if (numero < this._prezzoBase) {
                    const amount = this._prezzoBase.toLocaleString("it-IT", {
                        style: "currency", currency: "EUR",
                        minimumFractionDigits: 0, maximumFractionDigits: 0
                    });
                    return { ok: false, error: t("messages.amountLowerThanPrezzoBase", { amount }) };
                }
            }
            return { ok: true, error: "" };
        };

        // ── Validator: importo cauzione (required + minimo per tipo) ─────────
        const importoCauzioneValidator = (inputElement: HTMLInputElement): validation.ValidationResult => {
            if (!$(inputElement).is(":visible") || this._tipoCauzione === 4) {
                return { ok: true, error: "" };
            }

            const valoreOfferto = ($("#domanda-importo-offerto").val() as string) ?? "";
            const numeroOfferto = parseFloat(valoreOfferto.replace(/\./g, ""));

            const valore = ($(inputElement).val() as string) ?? "";
            const numero = parseFloat(valore.replace(/\./g, ""));

            if (isNaN(numero) || valore === "") {
                return { ok: false, error: t("messages.enterCautionAmount") };
            }
            if (this._cauzione != null) {
                let minimo = 0;
                if (this._tipoCauzione === 1) {
                    minimo = this._cauzione;
                } else if (this._tipoCauzione === 2 && !isNaN(numeroOfferto)) {
                    minimo = Math.ceil((numeroOfferto * this._cauzione) / 100);
                } else if (this._tipoCauzione === 3) {
                    minimo = Math.ceil((this._prezzoBase * this._cauzione) / 100);
                }
                if (numero < minimo) {
                    return {
                        ok: false,
                        error: t("messages.amountLowerThanMinimumCaution", {
                            amount: UI.formatEuroCurrency(minimo)
                        })
                    };
                }
            }
            return { ok: true, error: "" };
        };

        // ── Registra feedback live (on input) ────────────────────────────────
        validation.setValidatorOnInput("domanda-importo-offerto", importoOffertoValidator);
        validation.setValidatorOnInput("domanda-importo-cauzione", importoCauzioneValidator);
        validation.setValidatorOnInput("domanda-giorni-saldo", inputValidator);

        // ── Registra validazione al submit ───────────────────────────────────
        this.onSubmitValidator = async () => {
            validation.validate("domanda-importo-offerto", importoOffertoValidator);
            validation.validate("domanda-importo-cauzione", importoCauzioneValidator);
            validation.validate("domanda-giorni-saldo", inputValidator);
        };
    }

    private onSubmitValidator: () => void = async () => {
    }

    private async submitStep3(): Promise<void> {

        //Salva DATI OFFERTA E CAUZIONE
        $("#formStep3")
            .serializeArray()
            .forEach((field) => {
                this.formDataStep3[field.name] = field.value;
            });

        let domandaImportoOfferta: string = this.formDataStep3["Busta.ImportoOfferta"] as string;
        if (domandaImportoOfferta && domandaImportoOfferta.includes(".")) {
            domandaImportoOfferta = domandaImportoOfferta.replace(/\./g, '');
            this.formDataStep3["Busta.ImportoOfferta"] = domandaImportoOfferta;
        }

        let domandaCauzione: string = this.formDataStep3["Busta.ImportoCauzione"] as string;
        if (domandaCauzione && domandaCauzione.includes(".")) {
            domandaCauzione = domandaCauzione.replace(/\./g, '');
            this.formDataStep3["Busta.ImportoCauzione"] = domandaCauzione;
        }

        const mutuoValue = this.formDataStep3["Busta.Mutuo"];
        const mutuoBool = mutuoValue === "true"; // converte la stringa in booleano
        if (domandaImportoOfferta) {
            console.log("Dati Step 3:", this.formDataStep3);
            const url = window.BaseUrlWebApi + "AsteTelematiche/SalvaImportoECauzioneOfferta";
            try {
                await this.auth.fetchWithAuth("POST " + url, {
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        Id: this._bustaId,
                        ImportoOfferta: parseFloat(this.formDataStep3["Busta.ImportoOfferta"]),
                        ImportoCauzione: this.formDataStep3["Busta.ImportoCauzione"],
                        GGVersamentoASaldo: this.formDataStep3["Busta.GGVersamentoASaldo"],
                        Mutuo: mutuoBool
                    }),

                });

                console.log("salvataggio avvenuto con successo.");
            } catch (error) {
                console.info("Errore durante il salvataggio:", error);
                return;
            }
        } else
            return;

        return Promise.resolve();
    }

    /********************************************************************************************************/
    /*************************************** STEP 4 CAUZIONE E RESTITUZIONE *********************************/
    /********************************************************************************************************/

    private async ValidaStep04(): Promise<boolean> {
        if (this._tipoCauzione == 4) return true;

        this.addValidationFormStep4();
        let _ = this.spinner.spin();
        try {
            // Validazione del form
            this.onSubmitValidator();
            if (!this.theFormStep4.checkValidity()) {
                this.theFormStep4.classList.add('was-validated');
                return false;
            }

            const submitResult = await this.submitStep4();
            // ✅ Controlla se il submit è andato a buon fine
            if (!submitResult) {
                return false;
            }
            // Se non ci sono errori, ritorna true
            return true;
        } catch (error) {
            // Gestisci eventuali errori se necessario
            console.error("Errore nel submitStep4:", error);
            return false;
        } finally {
            this.spinner.stop();
        }
    }

    private addValidationFormStep4(): void {
        const that = this;
        const form = this.theFormStep4;
        // Rimuove la classe di validazione quando l'utente modifica i campi
        form.addEventListener("input", () => {
            form.classList.remove("was-validated");
        });

        const inputValidator = (inputElement: HTMLInputElement): validation.ValidationResult => {
            if (!$(inputElement).is(":visible")) {
                return { ok: true, error: "" };
            }
            const inputValue = $(inputElement).val() as string;
            const isValid = inputValue.length > 0;

            return {
                ok: isValid,
                error: isValid ? "" : t("validation.required")
            };
        }

        // Imposta i validatori sui campi testo
        validation.setValidatorOnInput("domanda-cro-cauzione", inputValidator);
        validation.setValidatorOnInput("domanda-data-ora-bonifico", inputValidator);
        validation.setValidatorOnInput("domanda-intestatario-cc", inputValidator);
        validation.setValidatorOnInput("domanda-istituto-credito", inputValidator);
        validation.setValidatorOnInput("domanda-iban", inputValidator);


        // Validazione al submit
        this.onSubmitValidator = async () => {
            validation.validate("domanda-cro-cauzione", inputValidator);
            validation.validate("domanda-data-ora-bonifico", inputValidator);
            validation.validate("domanda-intestatario-cc", inputValidator);
            validation.validate("domanda-istituto-credito", inputValidator);
            validation.validate("domanda-iban", inputValidator);
        };

    }

    private async submitStep4(): Promise<boolean> {
        //Salva allegato Cauzione
        const fileInputCauzione = document.getElementById("domanda-file-contabile") as HTMLInputElement;
        if (fileInputCauzione && fileInputCauzione.files && fileInputCauzione.files.length > 0) {
            const tipoDocumento = "CBL";

            const resultSaveAllegato: any = await this.SalvaDocumentoGara(tipoDocumento, fileInputCauzione);
            console.log("Result Save Allegato Cauzione:", resultSaveAllegato)

            if (!resultSaveAllegato.success) {

                // ✅ Estrai il messaggio (supporta sia JSON che stringa semplice)
                let errorMessage = t("messages.errorUploadingFile");
                try {
                    const errorData = typeof resultSaveAllegato.message === "string"
                        ? JSON.parse(resultSaveAllegato.message)
                        : resultSaveAllegato.message;
                    errorMessage = errorData?.Message || resultSaveAllegato.message || errorMessage;
                } catch {
                    errorMessage = resultSaveAllegato.message || errorMessage;
                }

                UI.confirmOneButton(t("common.atAttention"), errorMessage, "", function (result) {
                    if (result) {
                        $(fileInputCauzione).val("");
                        clearFileError(fileInputCauzione);
                    }
                });

                return false;
            }

            const item = resultSaveAllegato.data;
            // Nascondo il campo di upload se il file è stato caricato correttamente
            if (item && item.Id) {
                $("#div-upload-file-contabile-domanda").addClass("d-none");
                $("#domanda-file-contabile").val("").removeAttr("required");
            }

            // Aggiungo l'allegato alla lista degli allegati
            // $("#listaAllegatiCauzione").append(rowAllegato);
            // Aggiungo l'allegato alla lista degli allegati
            const divFileCauzione = document.getElementById("div-file-cauzione-domanda");
            if (!divFileCauzione) return false;

            // Template per la riga dell'allegato
            const id = item.Allegato.Id;
            const path = item.Allegato.Path;
            const descrizione = item.Allegato.Descrizione;

            const rowAllegato = `
                        <div class="d-flex align-items-center gap-2 allegato-cauzione-item">
                            <div class="d-flex gap-1 align-items-center">
                                <span class="material-symbols-outlined text-secondary">description</span>
                                <a class="d-flex flex-column lh-sm" href="../Asta/ScaricaDocumentoGara?data=${path}&nomeDoc=${descrizione}">
                                    <span class="fw-bold text-dark">${descrizione}</span>
                                </a>
                            </div>
                            <div role="button" class="text-danger" id="btn-elimina-doc-cauzione" type="button"
                                    class="btn p-0 delete-contabile"
                                    data-id="${id}" aria-label="${t("messages.delete")}" title="${t("messages.delete")}">
                                <span class="material-symbols-outlined">delete</span>
                            </button>
                        </div>
                        `;

            divFileCauzione.insertAdjacentHTML("beforeend", rowAllegato);

            //nascondo il campo di upload
            $("#div-upload-file-contabile-domanda").addClass("d-none");
            $("#domanda-file-contabile").val("").removeAttr("required");

            //Visualizzo il div che contiene il file caricato
            $("#div-file-cauzione-domanda").removeClass("d-none");

            // Aggiungo l'evento di cancellazione al nuovo bottone
            const btnElimina = divFileCauzione.querySelector("#btn-elimina-doc-cauzione") as HTMLElement;
            if (btnElimina) {
                btnElimina.addEventListener("click", async (e) => {
                    e.preventDefault();
                    const el = e.currentTarget as HTMLElement; // Recuoera il bottone cliccato
                    const allegatoId = el.getAttribute("data-id");
                    console.log("AllegatoId da eliminare:", allegatoId);
                    if (!allegatoId) return;
                    UI.confirm(t("common.confirm"), t("messages.confirmDelete"), "", async (result) => {

                        console.log("Conferma eliminazione allegato gara:", result);
                        if (!result) {
                            return;
                        }

                        await DeleteDocumentoGara(parseInt(allegatoId));

                        if (el && el.closest) {
                            el.closest(".allegato-cauzione-item")?.remove();
                        }

                        // Controlla se ci sono altri allegati
                        if ($(".allegato-cauzione-item").length === 0) {
                            $("#div-upload-file-contabile-domanda").removeClass("d-none");
                            $("#domanda-file-contabile").val("").attr("required", "required");
                        }
                        UI.confirmOneButton("", t("messages.attachmentDeletedSuccess"));
                    });
                });
            }
        }

        //Salva DATI CAUZIONE
        $("#formStep4")
            .serializeArray()
            .forEach((field) => {
                this.formDataStep4[field.name] = field.value;
            });

        const dataBonificoString = this.formDataStep4["Busta.DataBonificoCauzione"];
        let dataBonificoCauzione: string | null = null;

        if (dataBonificoString) {
            // ✅ Invia la stringa ISO locale così com'è, senza conversione UTC
            // dataBonificoString è già nel formato corretto "yyyy-MM-ddTHH:mm"
            // toISOString() sposterebbe l'ora in UTC perdendo il fuso orario locale
            dataBonificoCauzione = dataBonificoString;
        }

        console.log("Dati Step 4:", this.formDataStep4);
        const url = window.BaseUrlWebApi + "AsteTelematiche/SalvaCauzioneRestituzione";
        try {
            await this.auth.fetchWithAuth("POST " + url, {
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    Id: this._bustaId,
                    CroBonificoCauzione: this.formDataStep4["Busta.CroBonificoCauzione"],
                    DataBonificoCauzione: dataBonificoCauzione,
                    IntestatarioConto: this.formDataStep4["Busta.IntestatarioConto"],
                    Banca: this.formDataStep4["Busta.Banca"],
                    Iban: this.formDataStep4["Busta.Iban"]
                }),

            });

            console.log("salvataggio avvenuto con successo.");
        } catch (error) {
            console.info("Errore durante il salvataggio:", error);
            return false;
        }

        //return Promise.resolve();
        return true;
    }

    private async SalvaDocumentoGara(tipoDocumento: string, fileInput: any): Promise<any> {
        if (fileInput?.files?.length) {
            const file = fileInput.files[0];
            const maxSize = 4 * 1024 * 1024; // 4 MB in bytes

            // ✅ Controllo dimensione file
            if (file.size > maxSize) {
                // Mostra errore sotto l'input
                this.showFileError(fileInput, t("messages.fileTooLargeWithSize", { size: this.formatFileSize(file.size) }));
                return {
                    success: false,
                    message: t("messages.fileTooLargeMax4MB")
                };
            }

            // ✅ Rimuovi eventuali errori precedenti
            this.clearFileError(fileInput);

            const data = {
                UserId: this.userInfo.anagraficaId,
                VenditaId: Number($("#hdVenditaId").val()),
                Tipo: tipoDocumento,
                AstaId: this._idAstaTelematica,
                file: fileInput.files[0],
            };

            try {
                const allegatoGara: any = await uploadDocumentoGara(data);
                console.info("Allegato Gara:", allegatoGara.AllegatoId);

                return allegatoGara;
            } catch (error) {
                return { success: false, message: t("messages.errorUploadingDocument") };
            }
        }
    }
    /********************************************************************************************************/
    /*************************************** STEP 5 documenti proposta **************************************/
    /********************************************************************************************************/

    /**
     * Controlla se ci sono modifiche quando si passa allo step 4
     * e gestisce la cancellazione della PIA se necessario
     */
    private async controllaModifichePerStep5(): Promise<void> {
        const esisteDOP = this.verificaEsistenzaDOP();
        console.log("🔵 controllaModifichePerStep4 - Esiste DOP:", esisteDOP);
        console.log("🔵 controllaModifichePerStep4 - Snapshot corrente:", this._snapshotDatiProposta);

        if (esisteDOP) {
            // Controlla se ci sono state modifiche
            const ciSonoModifiche = await this.verificaModifiche();
            console.log("🔵 controllaModifichePerStep4 - Ci sono modifiche:", ciSonoModifiche);

            if (ciSonoModifiche) {
                // ✅ Mostra avviso e cancella la PIA
                const conferma = await new Promise<boolean>(resolve => {
                    UI.confirmOneButton(
                        t("messages.changesDetected"),
                        t("messages.changesDetectedMessage"),
                        "",
                        resolve
                    );
                });

                if (conferma) {
                    await this.rimuoviDOPEsistente();
                }
            }
        } else {
            // Nessuna PIA esistente, salva lo snapshot corrente
            this._snapshotDatiProposta = await this.creaSnapshotDatiProposta();
            console.log("🔵 controllaModifichePerStep5 - Snapshot salvato (nessuna DOP):", this._snapshotDatiProposta);
        }
    }



    private async ValidaStep05(): Promise<boolean> {
        this.addValidationFormStep5();
        let _ = this.spinner.spin();
        try {
            // Validazione del form
            this.onSubmitValidator();
            if (!this.theFormStep5.checkValidity()) {
                this.theFormStep5.classList.add('was-validated');
                return false;
            }

            const submitResult = await this.submitStep5();
            // ✅ Controlla se il submit è andato a buon fine
            if (!submitResult) {
                return false;
            }
            // Se non ci sono errori, ritorna true
            return true;
        } catch (error) {
            // Gestisci eventuali errori se necessario
            console.error("Errore nel submitStep5:", error);
            return false;
        } finally {
            this.spinner.stop();
        }
    }

    private addValidationFormStep5(): void {
        const that = this;
        const form = this.theFormStep5;
        // Rimuove la classe di validazione quando l'utente modifica i campi
        form.addEventListener("input", () => {
            form.classList.remove("was-validated");
        });

        const inputValidator = (inputElement: HTMLInputElement): validation.ValidationResult => {
            if (!$(inputElement).is(":visible")) {
                return { ok: true, error: "" };
            }
            const inputValue = $(inputElement).val() as string;
            const isValid = inputValue.length > 0;

            return {
                ok: isValid,
                error: isValid ? "" : t("validation.required")
            };
        }

        // ✅ Validatore personalizzato per i file
        const fileValidator = (inputElement: HTMLInputElement): validation.ValidationResult => {
            const $input = $(inputElement);
            const files = inputElement.files;

            // Controlla se è richiesto e non è presente
            if ($input.prop("required") && (!files || files.length === 0)) {
                that.showCustomFileError(inputElement, t("messages.documentNotUploaded"));
                return { ok: false, error: t("messages.documentNotUploaded") };
            }

            // Se c'è un file, controlla la dimensione
            if (files && files.length > 0) {
                const file = files[0];
                const maxSize = 4 * 1024 * 1024; // 4 MB

                if (file.size > maxSize) {
                    const errorMsg = t("messages.fileTooLargeWithSize", { size: that.formatFileSize(file.size) });
                    that.showCustomFileError(inputElement, errorMsg);
                    return { ok: false, error: errorMsg };
                }

                // File valido, rimuovi errori
                that.clearCustomFileError(inputElement);
            }

            return { ok: true, error: "" };
        };

        // Imposta i validatori sui campi testo
        validation.setValidatorOnInput("domanda-file-dop", fileValidator);
        validation.setValidatorOnInput("domanda-file-antiriciclaggio", fileValidator);


        // ✅ Aggiungi validazione al cambio file
        $("#domanda-file-dop, #domanda-file-antiriciclaggio").on("change", function () {
            const fileInput = this as HTMLInputElement;
            fileValidator(fileInput);
        });

        // Validazione al submit
        this.onSubmitValidator = async () => {
            validation.validate("domanda-file-dop", fileValidator);
            validation.validate("domanda-file-antiriciclaggio", fileValidator);
        };

    }

    private async GeneraPdfDop(bustaId: number): Promise<void> {
        let _ = this.spinner.spin();
        const url = window.BaseUrlWebApi + "AsteTelematiche/GeneraPdfDop?bustaId=" + bustaId;
        try {
            const response = await this.auth.fetchWithAuth("GET " + url, {
                cache: "no-cache",
                headers: { 'content-type': 'application/json' },
            });

            if (!response) {
                throw new Error(t("messages.errorGeneratingPDF"));
            }

            const blob = await response;
            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = downloadUrl;
            a.download = "DomandaPartecipazione.pdf";
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(downloadUrl);
        } catch (error) {
            console.info("Errore durante la generazione del pdf:", error);
            return;
        } finally {
            this.spinner.stop();
        }
    }

    private async submitStep5(): Promise<Boolean> {
        try {
            const fileInputDop = document.getElementById("domanda-file-dop") as HTMLInputElement;
            if (fileInputDop && fileInputDop.files && fileInputDop.files.length > 0) {
                const tipoDocumento = "DOP";

                const resultSaveAllegato: any = await this.SalvaDocumentoGara(tipoDocumento, fileInputDop);
                console.log("Result Save Allegato --> Domanda di partecipazione:", resultSaveAllegato)

                if (!resultSaveAllegato.success) {

                    // ✅ Estrai il messaggio (supporta sia JSON che stringa semplice)
                    let errorMessage = t("messages.errorUploadingFile");
                    try {
                        const errorData = typeof resultSaveAllegato.message === "string"
                            ? JSON.parse(resultSaveAllegato.message)
                            : resultSaveAllegato.message;
                        errorMessage = errorData?.Message || resultSaveAllegato.message || errorMessage;
                    } catch {
                        errorMessage = resultSaveAllegato.message || errorMessage;
                    }

                    const errorBody = `<span class="text-danger">${fileInputDop.files[0].name}</span>: ${errorMessage}`;

                    UI.confirmOneButton(t("common.atAttention"), errorBody, "", (result) => {
                        if (result) {
                            this.resetFileInput(fileInputDop, "fileDopName");
                        }
                    });

                    return false;
                }

                const item = resultSaveAllegato.data;
                // Nascondo il campo di upload se il file è stato caricato correttamente
                if (item && item.Allegato.Id) {
                    $("#div-upload-file-dop").addClass("d-none");
                    $("#domanda-file-dop").val("").removeAttr("required");
                }

                // Aggiungo l'allegato alla lista degli allegati
                // $("#listaAllegatiCauzione").append(rowAllegato);
                // Aggiungo l'allegato alla lista degli allegati
                const divFileDop = document.getElementById("div-file-dop");
                if (!divFileDop) return false;

                // Template per la riga dell'allegato
                const id = item.Allegato.Id;
                const path = item.Allegato.Path;
                const descrizione = item.Allegato.Descrizione;

                const rowAllegato = `
                <div class="allegato-dop-item d-flex align-items-center gap-2">
                        <div class="d-flex gap-1 align-items-center">
                            <span class="material-symbols-outlined text-secondary">description</span>
                            <a class="d-flex flex-column lh-sm" href="../Asta/ScaricaDocumentoGara?data=${path}&nomeDoc=${descrizione}">
                                <span class="fw-bold text-dark">${descrizione}</span>
                            </a>
                        </div>
                        <div class="d-flex gap-2 align-items-center">
                            <div id="btn-elimina-doc-dop"
                                 role="button"
                                 type="button"
                                 class="text-danger delete-dop"
                                 data-id="${id}" aria-label="${t("common.delete")}"
                                 title="${t("common.delete")}">
                                <span class="material-symbols-outlined">delete</span>
                            </div>
                        </div>
                    </div>
            `;

                divFileDop.insertAdjacentHTML("beforeend", rowAllegato);

                //Visualizzo il div che contiene il file caricato
                $("#div-file-dop").removeClass("d-none");

                // ✅ Salva snapshot dopo il caricamento della PIA
                this._snapshotDatiProposta = await this.creaSnapshotDatiProposta();
                this._existeDOP = true;
                console.log("✅ Snapshot salvato dopo caricamento DOP:", this._snapshotDatiProposta);

                // Aggiungo l'evento di cancellazione al nuovo bottone
                const btnEliminaDop = divFileDop.querySelector("#btn-elimina-doc-dop") as HTMLElement;
                if (btnEliminaDop) {
                    btnEliminaDop.addEventListener("click", async (e) => {
                        e.preventDefault();
                        const el = e.currentTarget as HTMLElement; // Recuoera il bottone cliccato
                        const allegatoId = el.getAttribute("data-id");
                        console.log("AllegatoId da eliminare:", allegatoId);
                        if (!allegatoId) return;
                        UI.confirm(t("common.confirm"), t("messages.confirmDelete"), "", async (result) => {

                            console.log("Conferma eliminazione allegato gara --> domanda di partecipazione:", result);
                            if (!result) {
                                return;
                            }

                            await DeleteDocumentoGara(parseInt(allegatoId));

                            if (el && el.closest) {
                                el.closest(".allegato-dop-item")?.remove();
                            }

                            // Controlla se ci sono altri allegati
                            if ($(".allegato-dop-item").length === 0) {
                                $("#div-upload-file-dop").removeClass("d-none");
                                $("#domanda-file-dop").val("").attr("required", "required");
                                $("#fileDopName").html("");
                            }
                            UI.confirmOneButton("", t("messages.attachmentDeletedSuccess"));
                        });
                    });
                }
            }

            const fileInputAntiRiciclaggio = document.getElementById("domanda-file-antiriciclaggio") as HTMLInputElement;
            if (fileInputAntiRiciclaggio && fileInputAntiRiciclaggio.files && fileInputAntiRiciclaggio.files.length > 0) {
                const tipoDocumento = "ARIC";

                const resultSaveAllegato: any = await this.SalvaDocumentoGara(tipoDocumento, fileInputAntiRiciclaggio);
                console.log("Result save allegato --> anti riciclaggio:", resultSaveAllegato)

                if (!resultSaveAllegato.success) {

                    // ✅ Estrai il messaggio (supporta sia JSON che stringa semplice)
                    let errorMessage = t("messages.errorUploadingFile");
                    try {
                        const errorData = typeof resultSaveAllegato.message === "string"
                            ? JSON.parse(resultSaveAllegato.message)
                            : resultSaveAllegato.message;
                        errorMessage = errorData?.Message || resultSaveAllegato.message || errorMessage;
                    } catch {
                        errorMessage = resultSaveAllegato.message || errorMessage;
                    }

                    const errorBody = `<span class="text-danger">${fileInputAntiRiciclaggio.files[0].name}</span>: ${errorMessage}`;

                    UI.confirmOneButton(t("common.atAttention"), errorBody, "", (result) => {
                        if (result) {
                            this.resetFileInput(fileInputAntiRiciclaggio, "fileAntiName");
                        }
                    });

                    return false;
                }

                const item = resultSaveAllegato.data;
                // Nascondo il campo di upload se il file è stato caricato correttamente
                if (item && item.Allegato.Id) {
                    $("#div-upload-file-antiriciclaggio").addClass("d-none");
                    $("#domanda-file-antiriciclaggio").val("").removeAttr("required");
                }

                // Aggiungo l'allegato alla lista degli allegati
                // $("#listaAllegatiCauzione").append(rowAllegato);
                // Aggiungo l'allegato alla lista degli allegati
                const divFileAntiRiciclaggio = document.getElementById("div-file-antiriciclaggio");
                if (!divFileAntiRiciclaggio) return false;

                // Template per la riga dell'allegato
                const id = item.Allegato.Id;
                const path = item.Allegato.Path;
                const descrizione = item.Allegato.Descrizione;

                const rowAllegato = `
                 <div class="allegato-antiriciclaggio-item d-flex align-items-center gap-2">
                        <div class="d-flex gap-1 align-items-center">
                            <span class="material-symbols-outlined text-secondary">description</span>
                            <a class="d-flex flex-column lh-sm" href="~/Asta/ScaricaDocumentoGara?data=${path}&nomeDoc=${descrizione}">
                                <span class="fw-bold text-dark">${descrizione}</span>
                            </a>
                        </div>
                        <div class="d-flex gap-2 align-items-center">
                            <div id="btn-elimina-doc-antiriciclaggio"
                                 role="button"
                                 type="button"
                                 class="text-danger delete-antiriciclaggio"
                                 data-id="${id}" aria-label="${t("common.delete")}"
                                 title="${t("common.delete")}">
                                <span class="material-symbols-outlined">delete</span>
                            </div>
                        </div>
                    </div>
            `;

                divFileAntiRiciclaggio.insertAdjacentHTML("beforeend", rowAllegato);

                //Visualizzo il div che contiene il file caricato
                $("#div-file-antiriciclaggio").removeClass("d-none");

                // Aggiungo l'evento di cancellazione al nuovo bottone
                const btnEliminaAntiRiciclaggio = divFileAntiRiciclaggio.querySelector("#btn-elimina-doc-antiriciclaggio") as HTMLElement;
                if (btnEliminaAntiRiciclaggio) {
                    btnEliminaAntiRiciclaggio.addEventListener("click", async (e) => {
                        e.preventDefault();
                        const el = e.currentTarget as HTMLElement; // Recuoera il bottone cliccato
                        const allegatoId = el.getAttribute("data-id");
                        console.log("AllegatoId da eliminare 'anti riciclaggio':", allegatoId);
                        if (!allegatoId) return;
                        UI.confirm(t("common.confirm"), t("messages.confirmDelete"), "", async (result) => {

                            console.log("Conferma eliminazione allegato gara 'anti riciclaggio':", result);
                            if (!result) {
                                return;
                            }

                            await DeleteDocumentoGara(parseInt(allegatoId));

                            if (el && el.closest) {
                                el.closest(".allegato-antiriciclaggio-item")?.remove();
                            }

                            // Controlla se ci sono altri allegati
                            if ($(".allegato-antiriciclaggio-item").length === 0) {
                                $("#div-upload-file-antiriciclaggio").removeClass("d-none");
                                $("#domanda-file-antiriciclaggio").val("").attr("required", "required");
                                $("#fileAntiName").html("");
                            }
                            UI.confirmOneButton("", t("messages.attachmentDeletedSuccess"));
                        });
                    });
                }
            }

            const fileInputAltroDocumento = document.getElementById("domanda-file-altro-documento") as HTMLInputElement;
            if (fileInputAltroDocumento && fileInputAltroDocumento.files && fileInputAltroDocumento.files.length > 0) {
                const tipoDocumento = "ALT";

                const resultSaveAllegato: any = await this.SalvaDocumentoGara(tipoDocumento, fileInputAltroDocumento);
                console.log("Result save allegato 'altro allegato':", resultSaveAllegato)

                if (!resultSaveAllegato.success) {

                    // ✅ Estrai il messaggio (supporta sia JSON che stringa semplice)
                    let errorMessage = t("messages.errorUploadingFile");
                    try {
                        const errorData = typeof resultSaveAllegato.message === "string"
                            ? JSON.parse(resultSaveAllegato.message)
                            : resultSaveAllegato.message;
                        errorMessage = errorData?.Message || resultSaveAllegato.message || errorMessage;
                    } catch {
                        errorMessage = resultSaveAllegato.message || errorMessage;
                    }

                    const errorBody = `<span class="text-danger">${fileInputAltroDocumento.files[0].name}</span>: ${errorMessage}`;

                    UI.confirmOneButton(t("common.atAttention"), errorBody, "", function (result) {
                        if (result) {
                            $(fileInputAltroDocumento).val("");
                            clearFileError(fileInputAltroDocumento);
                        }
                    });

                    return false;
                }

                const item = resultSaveAllegato.data;
                // Nascondo il campo di upload se il file è stato caricato correttamente
                if (item && item.Allegato.Id) {
                    $("#div-upload-file-altro-documento").addClass("d-none");
                    $("#domanda-file-altro-documento").val("");
                }

                // Aggiungo l'allegato alla lista degli allegati
                const divFileAltroDocumento = document.getElementById("divFileAltroDocumento");
                if (!divFileAltroDocumento) return false;

                // Template per la riga dell'allegato
                const id = item.Allegato.Id;
                const path = item.Allegato.Path;
                const descrizione = item.Allegato.Descrizione;

                const rowAllegato = `
                    <div class="allegato-altro-documento-item d-flex align-items-center gap-2">
                        <div class="d-flex gap-1 align-items-center">
                            <span class="material-symbols-outlined text-secondary">description</span>
                            <a class="d-flex flex-column lh-sm" href="../Asta/ScaricaDocumentoGara?data=${path}&nomeDoc=${descrizione}">
                                <span class="fw-bold text-dark">${descrizione}</span>
                            </a>
                        </div>
                        <div class="d-flex gap-2 align-items-center">
                            <div id="btn-elimina-altro-documento"
                                 role="button"
                                 type="button"
                                 class="text-danger delete-altrodocumento"
                                 data-id="${id}" aria-label="${t("common.delete")}"
                                 title="${t("offerta.altroAllegato")}">
                                <span class="material-symbols-outlined">delete</span>
                            </div>
                        </div>
                    </div>
            `;

                divFileAltroDocumento.insertAdjacentHTML("beforeend", rowAllegato);

                //Visualizzo il div che contiene il file caricato
                $("#div-file-altro-documento").removeClass("d-none");

                // Aggiungo l'evento di cancellazione al nuovo bottone
                const btnEliminaAltroDocumento = divFileAltroDocumento.querySelector("#btn-elimina-altro-documento") as HTMLElement;
                if (btnEliminaAltroDocumento) {
                    btnEliminaAltroDocumento.addEventListener("click", async (e) => {
                        e.preventDefault();
                        const el = e.currentTarget as HTMLElement; // Recuoera il bottone cliccato
                        const allegatoId = el.getAttribute("data-id");
                        console.log("AllegatoId da eliminare 'altro allegato':", allegatoId);
                        if (!allegatoId) return;
                        UI.confirm("Conferma", "Sei sicuro di volerlo eliminare?", "", async (result) => {

                            console.log("Conferma eliminazione allegato gara 'altro allegato':", result);
                            if (!result) {
                                return;
                            }

                            await DeleteDocumentoGara(parseInt(allegatoId));

                            if (el && el.closest) {
                                el.closest(".allegato-altro-documento-item")?.remove();
                            }

                            // Controlla se ci sono altri allegati
                            if ($(".allegato-altro-documento-item").length === 0) {
                                $("#div-upload-file-altro-documento").removeClass("d-none");
                            }
                            UI.confirmOneButton("", t("messages.attachmentDeletedSuccess"));
                        });
                    });
                }
            }


        } catch (error) {
            console.info("Errore durante il salvataggio:", error);
            return false;
        }

        return true;
    }

    /********************************************************************************************************/
    /******************************* STEP 6 Riepilogo e Invia Offerta ** ************************************/
    /********************************************************************************************************/
    private async refreshStep6(): Promise<void> {
        console.info("📋 Refresh Step 6 - Caricamento riepilogo");

        // ⚠️ TODO: Implementare l'endpoint API backend prima di abilitare questa chiamata
        // L'endpoint AsteTelematiche/GetDomandaPartecipazione non esiste ancora nel backend


        const url = window.BaseUrlWebApi + "AsteTelematiche/GetDomandaParteciapzione?venditaId=" + this._venditaId + "&anagraficaId=" + this.UserId;

        try {
            const domanda = await this.auth.fetchWithAuth("GET " + url, {
                cache: "no-cache",
                //headers: { 'content-type': 'application/json' },
            });

            if (domanda) {
                console.log("✅ Domanda di partecipazione recuperata:", domanda);

                // Popola i campi dello step 6 con i dati recuperati
                $("#riepilogo-nome").text(domanda.Nome);
                $("#riepilogo-cognome").text(domanda.Cognome);
                $("#riepilogo-importo-offerta").text(UI.formatEuroCurrency(domanda.ImportoOfferta));
                // ecc...
            } else {
                console.log("ℹ️ Nessuna domanda di partecipazione esistente");
            }

        } catch (error) {
            console.error("❌ Errore durante il recupero della domanda:", error);
        }


        // ✅ Per ora, lo step 6 mostra solo i dati già presenti nell'HTML
        console.log("ℹ️ Step 6 caricato (dati statici da HTML)");
    }


    /*----------------------------------------------------------------*/
    /*------------------ Metodi helper per la gestione errori -------------*/
    /*----------------------------------------------------------------*/
    // ✅ Metodo helper per mostrare l'errore
    private showFileError(fileInput: HTMLInputElement, message: string): void {
        // Aggiungi classe di errore all'input
        $(fileInput).addClass("is-invalid");

        // Cerca se esiste già un elemento per l'errore
        let errorElement = $(fileInput).siblings(".invalid-feedback");

        if (errorElement.length === 0) {
            // Crea l'elemento per l'errore se non esiste
            $(fileInput).after(`<div class="invalid-feedback d-block">${message}</div>`);
        } else {
            // Aggiorna il messaggio esistente
            errorElement.text(message).removeClass("d-none").addClass("d-block");
        }
    }

    // ✅ Metodo helper per rimuovere l'errore
    private clearFileError(fileInput: HTMLInputElement): void {
        $(fileInput).removeClass("is-invalid");
        $(fileInput).siblings(".invalid-feedback").addClass("d-none").removeClass("d-block");
    }

    // ✅ Metodo helper per formattare la dimensione del file
    private formatFileSize(bytes: number): string {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
    }

    /**
 * Mostra l'errore personalizzato per i file upload con la UI custom
 */
    private showCustomFileError(fileInput: HTMLInputElement, message: string): void {
        const $input = $(fileInput);

        // Trova il div divUploadFile più vicino
        const $uploadDiv = $input.closest('.divUploadFile');
        if ($uploadDiv.length > 0) {
            $uploadDiv.addClass('border-primary');
        }

        // Trova il div divUploadFileError successivo
        const $errorDiv = $uploadDiv.parent().find('.divUploadFileError');
        if ($errorDiv.length > 0) {
            $errorDiv.removeClass('d-none').text(message);
        }

        // Aggiungi anche la classe is-invalid per compatibilità
        $input.addClass('is-invalid');
    }

    /**
     * Rimuove l'errore personalizzato per i file upload
     */
    private clearCustomFileError(fileInput: HTMLInputElement): void {
        const $input = $(fileInput);

        // Rimuovi il bordo rosso dal div divUploadFile
        const $uploadDiv = $input.closest('.divUploadFile');
        if ($uploadDiv.length > 0) {
            $uploadDiv.removeClass('border-primary');
        }

        // Nascondi il messaggio di errore
        const $errorDiv = $uploadDiv.parent().find('.divUploadFileError');
        if ($errorDiv.length > 0) {
            $errorDiv.addClass('d-none');
        }

        // Rimuovi la classe is-invalid
        $input.removeClass('is-invalid');
    }

    /*----------------------------------------------------------------*/
    /*------------------ Metodi per tracking modifiche ---------------*/
    /*----------------------------------------------------------------*/

    /**
    * Inizializza lo snapshot all'avvio se esiste già una PIA caricata
    * (importante per il caso di rientro nel wizard)
    */
        private async inizializzaSnapshotSeEsisteDOP(): Promise < void> {
        const esistePIA = this.verificaEsistenzaDOP();

        if(esistePIA) {
            this._snapshotDatiProposta = await this.creaSnapshotDatiProposta();
            this._existeDOP = true;
            console.log("🔵 Snapshot iniziale creato all'avvio (DOP esistente):", this._snapshotDatiProposta);
        } else {
            console.log("🔵 Nessuna DOP esistente all'avvio, snapshot non creato");
        }
    }

    /**
     * Crea uno snapshot dei dati critici della proposta
     */
    private async creaSnapshotDatiProposta(): Promise<string> {
        // ✅ Normalizza l'importo rimuovendo separatori migliaia per confronto corretto
        const importoOffertoRaw = $("#domanda-importo-offerto").val() as string || "";
        const importoOffertoNormalizzato = importoOffertoRaw.replace(/\./g, '').replace(/,/g, '.');

        const importoCauzioneRaw = $("#domanda-importo-cauzione").val() as string || "";
        const importoCauzioneNormalizzato = importoCauzioneRaw.replace(/\./g, '').replace(/,/g, '.');

        const datiCritici = {
            // Step 1 - Dati profilo (prendi solo i dati essenziali)
            profiloId: this.UserId,
            nomeOfferente: $("#txtNome").val(),
            cognomeOfferente: $("#txtCognome").val(),
            cfOfferente: $("#txtCodiceFiscalePrivato").val(),
            dataNascitaOfferente: $("#txtDataNascita").val(),
            statoNascitaOfferente: $("#ddlStatoNasc").val(),
            idComuneNascidtaOfferente: $("#txtIdComuneNascita").val(),
            luogoNascidtaOfferente: $("#txtLuogoNascitaEstero").val(),
            emailOfferente: $("#txtEmail").val(),
            cellOfferente: $("#txtCellulare").val(),
            statoResOfferente: $("#ddlStatoRes").val(),
            comuneOfferente: $("#txtComune").val(),
            capOfferente: $("#txtCap").val(),
            provinciaOfferente: $("#txtProvincia").val(),
            indirizzoOfferente: $("#txtIndirizzo").val(),

            // Step 2 - Modalità acquisto e soggetti
            modalitaAcquisto: $("#modalitaAcquisto").val(),
            soggetti: await this.recuperaDatiSoggetti(), // ✅ Usa metodo dedicato

            // Step 3 - Dati cauzione (normalizzato per confronto)
            importoOfferto: importoOffertoNormalizzato,
            importoCauzione: importoCauzioneNormalizzato,
            ggVersamentoASaldo: $("#domanda-giorni-saldo").val()
        };

        // Crea hash/stringa dei dati
        const snapshot = JSON.stringify(datiCritici);
        console.log("📸 Snapshot creato:", datiCritici);
        return snapshot;
    }

    /**
     * Recupera i dati completi dei soggetti (da DOM con data attributes o da API)
     */
    private async recuperaDatiSoggetti(): Promise<any[]> {
        const soggetti: any[] = [];

        // ✅ recupero dati soggetti acquirenti da API
        if (soggetti.length == 0) {
            console.log("📡 Recupero dati soggetti da API...");
            try {
                const url = window.BaseUrlWebApi + `SoggettoVenditaAcquisto/GetDataByBustaId?bustaId=${this._bustaId}`;
                const response = await this.auth.fetchWithAuth("GET " + url, {
                    cache: "no-cache",
                    headers: { 'content-type': 'application/json' },
                });

                if (response && response.length > 0) {
                    return response.map((s: any) => ({
                        id: s.Id,
                        personaGiuridica: s.PersonaGiuridica,
                        quota: s.Quota,
                        nome: s.Nome,
                        cognome: s.Cognome,
                        denominazione: s.Denominazione,
                        codiceFiscale: s.CodiceFiscale,
                        partitaIva: s.PartitaIva,
                        codiceSDI: s.CodiceSdi,
                        dataNascita: s.DataNascita,
                        idStatoNascita: s.IdStatoNascita,
                        idComuneNascita: s.IdComuneNascita,
                        luogoNascitaEstero: s.LuogoNascitaEstero,
                        idStatoResidenza: s.IdStatoResidenza,
                        idComuneResidenza: s.IdComuneResidenza,
                        capResidenza: s.CapResidenza,
                        idProvinciaResidenza: s.IdProvinciaResidenza,
                        luogoResidenzaEstero: s.LuogoResidenzaEstero,
                    }));
                }
            } catch (error) {
                console.error("Errore recupero soggetti:", error);
            }
        }

        return soggetti;
    }

    /**
     * Controlla se ci sono state modifiche rispetto allo snapshot
     */
    private async verificaModifiche(): Promise<boolean> {

        if (!this._snapshotDatiProposta) {
            console.log("🔴 verificaModifiche - Nessuno snapshot precedente");
            return false; // Nessuno snapshot precedente
        }

        const snapshotCorrente = await this.creaSnapshotDatiProposta();
        const sonoUguali = this._snapshotDatiProposta === snapshotCorrente;

        console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");
        console.log("🔍 CONFRONTO SNAPSHOT:");
        console.log("📌 Snapshot SALVATO:", this._snapshotDatiProposta);
        console.log("📌 Snapshot CORRENTE:", snapshotCorrente);
        console.log(sonoUguali ? "✅ sono uguali" : "❌ non sono uguali");
        console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");

        // Parsing per confronto dettagliato
        try {
            const salvato = JSON.parse(this._snapshotDatiProposta);
            const corrente = JSON.parse(snapshotCorrente);

            console.log("🔎 Dettaglio confronto:");
            console.log("  • ProfiloId:", salvato.profiloId, "vs", corrente.profiloId, salvato.profiloId === corrente.profiloId ? "✅" : "❌");
            console.log("  • Nome offerente:", salvato.nomeOfferente, "vs", corrente.nomeOfferente, salvato.nomeOfferente === corrente.nomeOfferente ? "✅" : "❌");
            console.log("  • Cognome offerente:", salvato.cognomeOfferente, "vs", corrente.cognomeOfferente, salvato.cognomeOfferente === corrente.cognomeOfferente ? "✅" : "❌");
            console.log("  • Modalità acquisto:", salvato.modalitaAcquisto, "vs", corrente.modalitaAcquisto, salvato.modalitaAcquisto === corrente.modalitaAcquisto ? "✅" : "❌");
            console.log("  • Importo cauzione:", salvato.importoCauzione, "vs", corrente.importoCauzione, salvato.importoCauzione === corrente.importoCauzione ? "✅" : "❌");
            console.log("  • Num. soggetti:", salvato.soggetti.length, "vs", corrente.soggetti.length, salvato.soggetti.length === corrente.soggetti.length ? "✅" : "❌");

            // ✅ Confronto dettagliato soggetti
            if (salvato.soggetti.length > 0 || corrente.soggetti.length > 0) {
                console.log("  📋 Dettaglio soggetti:");
                const maxLen = Math.max(salvato.soggetti.length, corrente.soggetti.length);
                for (let i = 0; i < maxLen; i++) {
                    const sSalv = salvato.soggetti[i];
                    const sCorr = corrente.soggetti[i];
                    if (sSalv && sCorr) {
                        const uguali = JSON.stringify(sSalv) === JSON.stringify(sCorr);
                        console.log(`    [${i}] ${sSalv.nominativo || sSalv.id} ${uguali ? "✅" : "❌"}`);
                        if (!uguali && sSalv.nominativo) {
                            console.log(`        • CF: ${sSalv.codiceFiscale} vs ${sCorr.codiceFiscale}`);
                            console.log(`        • Quota: ${sSalv.quota} vs ${sCorr.quota}`);
                        }
                    } else if (sSalv) {
                        console.log(`    [${i}] ${sSalv.nominativo || sSalv.id} ❌ (rimosso)`);
                    } else if (sCorr) {
                        console.log(`    [${i}] ${sCorr.nominativo || sCorr.id} ❌ (aggiunto)`);
                    }
                }
            }
        } catch (e) {
            console.error("Errore nel parsing degli snapshot:", e);
        }

        console.log(sonoUguali ? "✅ Nessuna modifica rilevata" : "⚠️ MODIFICHE RILEVATE!");
        console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");

        return !sonoUguali;
    }

    /**
     * Controlla se esiste una DOP già caricata
     */
    private verificaEsistenzaDOP(): boolean {
        const numDOP = $(".allegato-dop-item").length;
        console.log("🔵 verificaEsistenzaDOP - Numero DOP trovate nel DOM:", numDOP, "| Flag _existeDOP:", this._existeDOP);
        return numDOP > 0 || this._existeDOP;
    }

    /**
     * Cancella la PIA esistente e mostra il form di upload
     */
    private async rimuoviDOPEsistente(): Promise<void> {
        const dopCancellata = await DeleteDocumentoGaraByIdATByUserIdAndTipo(this._idAstaTelematica, this.UserId, "DOP");

        if (dopCancellata) {
            // Rimuovi dalla UI
            $(".allegato-dop-item").remove();

            // Mostra il form di upload
            $("#div-upload-file-dop").removeClass("d-none");
            $("#domanda-file-dop").val("").attr("required", "required");
            $("#div-file-dop").addClass("d-none");

            // Reset snapshot
            this._snapshotDatiProposta = null;
            this._existeDOP = false;

            console.log("🗑️ DOP cancellata a causa di modifiche nei dati");
        }
    }

    /**
    * Resetta completamente un input file e il suo display associato
    */
    private resetFileInput(fileInput: HTMLInputElement, displayId: string): void {
        $(fileInput).val("");
        clearCustomFileError(fileInput);
        $(`#${displayId}`).empty();
    }

}

export default AdPropostaAcquisto;
